export default {
  es: {
    title1: "Te ofrecemos",
    title2: "mucho más",
    breadcrumb: {
      queOfrecemos: "Qué ofrecemos",
      muchaLuz: "Mucha más Luz",
      muchoGas: "Mucho más Gas",
    },
    ventajas: {
      title: "Ser de iner tiene muchas",
      titleBold: "Ventajas",
      description:
        "Ser de Iner tiene muchos beneficios, descubre cómo complementar tu tarifa de luz y gas.",
    },
    selector: {
      inerLuz: "Iner Luz",
      inerGas: "Iner Gas",
    },
    serviciosLuz: {
      title: "Servicios para iners",
      subtitle: "Iner Luz",
      urgencias: {
        title: "URGENCIAS Y AVERÍAS ELÉCTRICAS",
        check1: "Nos encargamos de todo",
        check2: "365 días al año, 7 días a la semana, 24h",
        averias: {
          title: "AVERÍAS ELÉCTRICAS",
          description: "Nuestro equipo se desplazará hasta tu casa en menos de 3 horas para proceder con la reparación. ¿Cómo sé si es una avería urgente? Pues porque no tienes suministro eléctrico en toda la casa y eres el único del edificio en esa situación o porque dicha avería pertenece a la toma de corriente del frigorífico (nevera y/o congelador). En ese caso cuentas con el desplazamiento hasta tu casa totalmente gratuito de un profesional en menos de 3 horas y la mano de obra gratuita durante las primeras 3 horas de trabajo."
        },
        inerHogar: {
          title: "INER HOGAR",
          description: "¿Se te ha estropeado uno de los electrodomésticos de tu hogar? En 48 horas estaremos allí para arreglarlo. ¿Cuáles son los electrodomésticos que podemos arreglar? La lavadora, secadora, frigorífico, cocina eléctrica, horno, campana, lavavajillas, congelador. Todo esto con una disposición de hasta 3 horas de mano de obra."
        }
      },
      manitas: {
        title: "UN MANITAS EN CASA",
        check: "Nosotros nos encargamos",
        inerTranquilidad: {
          title: "INER TRANQUILIDAD",
          description: "¿Quieres más? Contrata el servicio más completo en la modalidad \"Iner Tranquilidad\" y además de todo lo anterior también dispondrás de un servicio de bricolaje que es una maravilla... ¿Has comprado un mueble por módulos y no sabes cómo montarlo?, o tienes unas cortinas pendientes de colgar y nunca tienes tiempo o sencillamente no te apetece. No creemos que esas cosas sean lo más importante que tengas que hacer hoy, así que descuelga el teléfono y llámanos, nosotros lo haremos por ti."
        }
      },
      cochesElectricos: {
        title: "COCHES ELÉCTRICOS",
        check1: "Te instalamos tu punto de recarga donde necesites",
        check2: "Te ofrecemos el mejor precio para cargar tu coche eléctrico",
        tarifasEspeciales: {
          title: "Tarifas especiales",
          description: "Esta tarifa está especialmente pensada para quienes necesitan aprovechar al máximo los horarios nocturnos más económicos para recargar su vehículo eléctrico. Sal de casa con la batería siempre cargada."
        },
        dondeQuieras: {
          title: "Dónde quieras",
          description: "Te instalamos el punto de recarga donde necesites. En función de las características de tu vivienda y de la zona de aparcamiento, las soluciones serán distintas. Además nos aseguraremos de que tengas la potencia necesaria y la mejor tarifa para tus necesidades."
        }
      },
      precios: {
        title: "Tarifas",
        subtitle: "para tenerlo todo controlado",
        averiasElectricas: "Averías eléctricas",
        averiasInerHogar: "Averías eléctricas + Iner Hogar",
        averiasInerHogarTranquilidad: "Averías eléctricas + Iner Hogar + Iner Tranquilidad",
        cocheElectrico: "Coche eléctrico",
        consultanos: "CONSÚLTANOS",
        preciosSinIva: "Precios sin IVA"
      }
    },
    serviciosGas: {
      title: "Servicios para iners",
      subtitle: "Iner Gas",
      maximaSeguridad: {
        title: "Máxima seguridad en tu hogar",
        check1: "Revisión de calderas y solución de averías.",
        check2: "Nosotros nos encargamos de todo.",
        olvidaPreocupaciones: {
          title: "Olvida tus preocupaciones",
          description1: "Con Iner Gas te ofrecemos una revisión bienal de tu caldera, con desplazamiento y mano de obra incluidos durante la revisión preventiva. Si encontramos algo que no va bien, te preparamos un presupuesto gratuito sin compromiso.",
          description2: "¿Hace ruido? ¿Notas que no calienta como antes? Pide tu revisión y uno de nuestros profesionales acudirá a tu domicilio para dejarlo todo revisado y funcionando como debe. Además, tienes una garantía de 6 meses sobre las reparaciones realizadas"
        }
      },
      inerTranquilidad: {
        title: "INER TRANQUILIDAD",
        check1: "Nos encargamos de todo",
        check2: "Tu tranquilidad es lo más importante",
        reparacion: {
          title: "Reparación y revisión de calderas",
          description: "Y para más seguridad... \"Iner Tranquilidad Gas\". Revisiones anuales con desplazamiento y mano de obra incluidos. Si se detecta alguna anomalía, te ofreceremos un presupuesto gratuito para su reparación."
        }
      },
      precios: {
        title: "Tarifas",
        subtitle: "para tenerlo todo controlado",
        basico: {
          title: "Básico Iner Gas",
          description: "Revisión BIENAL, desplazamiento gratuito, 3 horas mano de obra, presupuesto gratuito para recambios y 6 meses de garantía por las reparaciones realizadas."
        },
        completo: {
          title: "Completo Iner Tranquilidad Gas",
          description: "Revisión ANUAL, desplazamiento gratuito, 3 horas mano de obra, presupuesto gratuito para recambios y 6 meses de garantía por las reparaciones realizadas."
        }
      }
    },
    bannerContacta: {
      title1: "Lo quiero",
      subtitle1:
        "¿Quieres incluir alguno de estos servicios en tu factura de Iner Luz?",
      subtitle2: "¡Ponte en contacto con nosotros!",
      telefono: "900 848 402",
      email: "iner@inerenergia.es",
      formulario: "Ir al formulario",
    },
  },
  en: {
    title1: "We offer you",
    title2: "much more",
    breadcrumb: {
      queOfrecemos: "What we offer",
      muchaLuz: "Much more Light",
      muchoGas: "Much more Gas",
    },
    ventajas: {
      title: "Being from Iner has many",
      titleBold: "Advantages",
      description:
        "Being from Iner has many benefits, discover how to complement your electricity and gas tariff.",
    },
    selector: {
      inerLuz: "Iner Light",
      inerGas: "Iner Gas",
    },
    serviciosLuz: {
      title: "Services for Iners",
      subtitle: "Iner Light",
      urgencias: {
        title: "ELECTRICAL EMERGENCIES AND BREAKDOWNS",
        check1: "We take care of everything",
        check2: "365 days a year, 7 days a week, 24h",
        averias: {
          title: "ELECTRICAL BREAKDOWNS",
          description: "Our team will come to your home in less than 3 hours to proceed with the repair. How do I know if it's an urgent breakdown? Well, because you don't have electrical supply in the entire house and you're the only one in the building in that situation or because that breakdown belongs to the refrigerator's power outlet (fridge and/or freezer). In that case, you have a completely free visit to your home by a professional in less than 3 hours and free labor during the first 3 hours of work."
        },
        inerHogar: {
          title: "INER HOME",
          description: "Has one of your home appliances broken down? In 48 hours we'll be there to fix it. Which appliances can we fix? The washing machine, dryer, refrigerator, electric stove, oven, hood, dishwasher, freezer. All this with up to 3 hours of labor available."
        }
      },
      manitas: {
        title: "A HANDYMAN AT HOME",
        check: "We take care of it",
        inerTranquilidad: {
          title: "INER TRANQUILITY",
          description: "Want more? Hire the most complete service in the \"Iner Tranquility\" mode and in addition to everything above, you'll also have a DIY service that's wonderful... Have you bought a modular piece of furniture and don't know how to assemble it?, or do you have curtains pending to hang and you never have time or simply don't feel like it. We don't think those things are the most important thing you have to do today, so pick up the phone and call us, we'll do it for you."
        }
      },
      cochesElectricos: {
        title: "ELECTRIC CARS",
        check1: "We install your charging point where you need it",
        check2: "We offer you the best price to charge your electric car",
        tarifasEspeciales: {
          title: "Special rates",
          description: "This rate is especially designed for those who need to take maximum advantage of the most economical night hours to recharge their electric vehicle. Leave home with the battery always charged."
        },
        dondeQuieras: {
          title: "Wherever you want",
          description: "We install the charging point where you need it. Depending on the characteristics of your home and the parking area, the solutions will be different. In addition, we will ensure that you have the necessary power and the best rate for your needs."
        }
      },
      precios: {
        title: "Rates",
        subtitle: "to have everything under control",
        averiasElectricas: "Electrical breakdowns",
        averiasInerHogar: "Electrical breakdowns + Iner Home",
        averiasInerHogarTranquilidad: "Electrical breakdowns + Iner Home + Iner Tranquility",
        cocheElectrico: "Electric car",
        consultanos: "ASK US",
        preciosSinIva: "Prices without VAT"
      }
    },
    serviciosGas: {
      title: "Services for Iners",
      subtitle: "Iner Gas",
      maximaSeguridad: {
        title: "Maximum security in your home",
        check1: "Boiler inspection and breakdown solution.",
        check2: "We take care of everything.",
        olvidaPreocupaciones: {
          title: "Forget your worries",
          description1: "With Iner Gas we offer you a biennial inspection of your boiler, with free travel and labor included during the preventive inspection. If we find something that's not working well, we'll prepare a free, no-obligation quote for you.",
          description2: "Is it making noise? Do you notice it's not heating like before? Request your inspection and one of our professionals will come to your home to leave everything checked and working as it should. In addition, you have a 6-month warranty on repairs performed."
        }
      },
      inerTranquilidad: {
        title: "INER TRANQUILITY",
        check1: "We take care of everything",
        check2: "Your peace of mind is the most important thing",
        reparacion: {
          title: "Boiler repair and inspection",
          description: "And for more security... \"Iner Tranquility Gas\". Annual inspections with free travel and labor included. If any anomaly is detected, we will offer you a free quote for its repair."
        }
      },
      precios: {
        title: "Rates",
        subtitle: "to have everything under control",
        basico: {
          title: "Basic Iner Gas",
          description: "BIENNIAL inspection, free travel, 3 hours labor, free quote for spare parts and 6 months warranty on repairs performed."
        },
        completo: {
          title: "Complete Iner Tranquility Gas",
          description: "ANNUAL inspection, free travel, 3 hours labor, free quote for spare parts and 6 months warranty on repairs performed."
        }
      }
    },
    bannerContacta: {
      title1: "I want it",
      subtitle1:
        "Do you want to include any of these services in your Iner Light bill?",
      subtitle2: "Get in touch with us!",
      telefono: "900 848 402",
      email: "iner@inerenergia.es",
      formulario: "Go to form",
    },
  },
};



// WEBPACK FOOTER //
// ./src/translations/ofrecemos-mucho-mas.js